<template>
  <div class="inquiry">
    <div class="page_title flex_between">
      <span> 病历详情</span>
      <span>
        <el-button
          type="primary"
          style="width: 92px"
          size="medium"
          @click="submit"
          >保存</el-button
        >
        <el-button plain style="width: 92px" size="medium" @click="back"
          >返回</el-button
        >
      </span>
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div style="margin-bottom: 10px">
          <span style="font-weight: 700; margin-right: 10px">患者是否填写</span>
          <span v-if="is_inquiry == 1">已填写</span>
          <span v-if="is_inquiry == 0">未填写</span>
        </div>
        <div>
          <span style="font-weight: 700; margin-right: 10px"
            >问诊单作用说明</span
          >
          <!-- <span>{{ desc }}</span> -->
        </div>
        <el-divider></el-divider>
        <div class="content-box">
          <el-form
            ref="formRef"
            :model="formData"
            :rules="rules"
            label-position="top"
            label-width="180px"
          >
            <div v-for="(item, index) in formConfig" :key="index">
              <!-- 单选组件 -->
              <template v-if="item.type === 'radio'">
                <el-form-item
                  :prop="item.prop"
                  :label="`${item.sort}.${item.label}`"
                  v-if="shouldShow(item)"
                >
                  <el-radio-group
                    v-model="formData[item.prop]"
                    :disabled="isDisabled"
                    @change="handleRadioChange(item)"
                  >
                    <el-radio
                      v-for="opt in item.options"
                      :key="opt.value"
                      :label="opt.value"
                    >
                      {{ opt.label }}
                    </el-radio>
                  </el-radio-group>

                  <!-- 特殊处理：起效时间选择"其他"时显示输入框 -->
                  <template
                    v-if="
                      item.prop === 'effectTime' &&
                      formData.effectTime === 'other'
                    "
                  >
                    <el-input
                      v-model="formData.effectTimeOther"
                      placeholder="请输入起效时间"
                      maxlength="100"
                      style="width: 100px; margin-left: 15px"
                    ></el-input
                    >&nbsp;天
                  </template>
                </el-form-item>
              </template>

              <!-- 多选组件 -->
              <template v-else-if="item.type === 'checkbox'">
                <el-form-item
                  :prop="item.prop"
                  :label="`${item.sort}.${item.label}`"
                  v-if="shouldShow(item)"
                >
                  <el-checkbox-group
                    v-model="formData[item.prop]"
                    :disabled="isDisabled"
                  >
                    <el-checkbox
                      v-for="opt in item.options"
                      :key="opt.value"
                      :label="opt.value"
                    >
                      {{ opt.label }}
                    </el-checkbox>
                  </el-checkbox-group>
                </el-form-item>
              </template>

              <!-- 上传组件 -->
              <template v-else-if="item.type === 'upload'">
                <el-form-item
                  :label="`${item.sort ? item.sort + '.' : ''}${item.label}`"
                  :prop="item.prop"
                  v-if="shouldShow(item)"
                >
                  <div style="display: flex; align-items: center; gap: 10px">
                    <UploadImg
                      v-for="(aitem, aindex) in formData[item.prop]"
                      :key="aindex + aitem.pic"
                      :f_data="item"
                      :f_thumb="aitem.pic"
                      :f_thumb_str="aitem.path"
                      :index="aindex"
                      @emitImg="emitImg"
                    ></UploadImg>
                  </div>
                </el-form-item>
              </template>

              <!-- 文本域组件 -->
              <template v-else-if="item.type === 'textarea'">
                <el-form-item
                  :prop="item.prop"
                  :label="`${item.sort}.${item.label}`"
                  v-if="shouldShow(item)"
                >
                  <el-input
                    :disabled="isDisabled"
                    type="textarea"
                    v-model="formData[item.prop]"
                    :rows="4"
                    show-word-limit
                    maxlength="300"
                    placeholder="请输入内容"
                  ></el-input>
                </el-form-item>
              </template>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
import UploadImg from "@/components/uploadImg/index";
export default {
  components: {
    UploadImg,
  },
  data() {
    // 自定义验证规则：当选择"其他"时必须输入时间
    const validateEffectTime = (rule, value, callback) => {
      if (value === "other" && !this.formData.effectTimeOther) {
        callback(new Error("请输入起效时间"));
      } else if (!value) {
        callback(new Error("请选择有效结果起效时间"));
      } else {
        callback();
      }
    };
    const validateImg = (rule, value, callback) => {
      console.log(value, "value");

      if (value.length == 1) {
        callback(new Error("请上传图片"));
      } else {
        callback();
      }
    };
    return {
      is_inquiry: this.$route.query.is_inquiry,
      // desc: "",
      // 表单配置数据结构
      formConfig: [
        {
          sort: 1,
          type: "radio",
          label: "中医病证疗效评定标准——疗效初步判断标准",
          prop: "standard",
          required: true,
          options: [
            { label: "临床痊愈：证候积分减少≥95%", value: 1 },
            { label: "显效：证候积分≥70%且<95%", value: 2 },
            { label: "有效：证候积分≥30%且<70%", value: 3 },
            { label: "无效：证候积分<30%", value: 4 },
          ],
        },
        {
          sort: 2,
          type: "radio",
          label: "有效结果起效时间",
          prop: "effectTime",
          required: true,
          options: [
            { label: "1天", value: 1 },
            { label: "2天", value: 2 },
            { label: "3天", value: 3 },
            { label: "4天", value: 4 },
            { label: "5天", value: 5 },
            { label: "6天", value: 6 },
            { label: "7天", value: 7 },
            { label: "其他", value: "other" },
          ],
        },
        {
          sort: 3,
          type: "radio",
          label: "是否有不良反应",
          prop: "hasSideEffect",
          required: true,
          options: [
            { label: "否", value: 0 },
            { label: "是", value: 1 },
          ],
        },
        {
          sort: 4,
          type: "radio",
          label: "您的不良反应主要体现在哪个系统",
          prop: "sideEffectSystems",
          required: true,
          options: [
            { label: "血液系统反应", value: 1 },
            { label: "胃肠道反应", value: 2 },
            { label: "肝肾功能反应", value: 3 },
            { label: "皮疹反应", value: 4 },
            { label: "过敏反应", value: 5 },
            { label: "神经系统反应", value: 6 },
            { label: "心血管系统反应", value: 7 },
            { label: "其他反应", value: 8 },
          ],
          showWhen: "hasSideEffect", // 条件显示
        },
        {
          sort: 5,
          type: "upload",
          label: "请上传你的血像检查报告",
          prop: "hemogramReports",
          required: true,
          limit: 9, // 最大上传数量
          showWhen: "sideEffectSystems", //条件显示
        },
        {
          sort: 5,
          type: "checkbox",
          label: "您的胃肠道反应主要是",
          prop: "gastrointestinalReactionSymptoms",
          required: true,
          options: [
            { label: "恶心", value: 1 },
            { label: "呕吐", value: 2 },
            { label: "腹泻", value: 3 },
            { label: "腹痛", value: 4 },
            { label: "便秘", value: 5 },
          ],
          showWhen: "sideEffectSystems", // 条件显示
        },
        {
          sort: 5,
          type: "upload",
          label: "请上传您的肝肾功能报告",
          prop: "liverKidneyReports",
          required: true,
          limit: 9, // 最大上传数量
          showWhen: "sideEffectSystems", //条件显示
        },
        {
          sort: 5,
          type: "radio",
          label: "您的皮疹反应主要是",
          prop: "rashReactionSymptoms",
          required: true,
          options: [
            {
              label:
                "局部皮疹（如红斑、丘疹），面积＜10%体表面积，伴轻度瘙痒或干燥",
              value: 1,
            },
            {
              label:
                "皮疹范围10%-30%体表面积，伴明显瘙痒、脱屑或水疱，可能伴局部感染（如脓疱）",
              value: 2,
            },
            {
              label:
                "皮疹范围＞30%体表面积，广泛水疱、糜烂、渗出，伴剧烈瘙痒或疼痛，可能伴全身症状（发热）",
              value: 3,
            },
            {
              label:
                "重症多形红斑（SJS）、中毒性表皮坏死松解症（TEN），全身表皮剥脱＞30%，伴器官衰竭",
              value: 4,
            },
            { label: "直接导致死亡", value: 5 },
          ],
          showWhen: "sideEffectSystems", // 条件显示
        },
        {
          sort: 5,
          type: "radio",
          label: "您的过敏反应主要是",
          prop: "allergicReactionSymptoms",
          required: true,
          options: [
            {
              label:
                "仅皮肤症状：•局部荨麻疹（风团、红斑）•轻度瘙痒 •血管性水肿（如口唇肿胀）",
              value: 1,
            },
            {
              label:
                "多系统受累：•皮肤症状加重 •呼吸道：鼻塞、喷嚏、声音嘶哑 •胃肠道：恶心、腹痛 •轻度呼吸困难（无低氧）",
              value: 2,
            },
            {
              label:
                "危及生命的系统损害：•呼吸困难（喘息、喉头水肿）•低血压（收缩压下降≥30%）•意识模糊、濒死感 •呕吐/腹泻（持续）",
              value: 3,
            },
            {
              label:
                "重症多形红斑（SJS）、中毒性表皮坏死松解症（TEN），全身表皮剥脱＞30%，伴器官衰竭",
              value: 4,
            },
            {
              label:
                "循环衰竭：•血压测不出或严重低血压（收缩压＜90 mmHg） •意识丧失",
              value: 5,
            },
          ],
          showWhen: "sideEffectSystems", // 条件显示
        },
        {
          sort: 5,
          type: "radio",
          label: "您的周围神经主要反应是",
          prop: "neurologicalSymptoms",
          required: true,
          options: [
            {
              label:
                "•无症状或轻度感觉异常（麻木、刺痛）•腱反射减弱，但肌力正常",
              value: 1,
            },
            {
              label:
                "•中度症状（疼痛、烧灼感），影响肢体远端 •轻度肌力下降（如足背屈无力）•振动觉或温度觉减退",
              value: 2,
            },
            {
              label:
                "•严重疼痛或感觉丧失，累及肢体近端 •显著肌力下降（行走困难、足下垂）•自主神经症状（体位性低血压、排尿障碍）",
              value: 3,
            },
            {
              label:
                "•呼吸肌麻痹（如吉兰-巴雷综合征）•完全性感觉运动障碍，伴器官衰竭",
              value: 4,
            },
            { label: "直接导致死亡", value: 5 },
          ],
          showWhen: "sideEffectSystems", // 条件显示
        },
        {
          sort: 6,
          type: "radio",
          label: "您的头痛主要反应是",
          prop: "headacheSymptom",
          required: true,
          options: [
            { label: "可耐受，不影响日常活动，无需用药", value: 1 },
            {
              label: "明显不适，需口服止痛药（如布洛芬），部分活动受限",
              value: 2,
            },
            { label: "直接导致死亡", value: 3 },
          ],
          showWhen: "sideEffectSystems", // 条件显示
        },
        {
          sort: 5,
          type: "radio",
          label: "您的心血管系统不良反应主要是",
          prop: "cardiovascularSymptoms",
          required: true,
          options: [
            { label: "偶发心绞痛、轻度血压波动、无症状心律失常", value: 1 },
            {
              label: "不稳定心绞痛、中度高血压、需药物控制的心律失常",
              value: 2,
            },
            {
              label: "急性心肌梗死、严重心力衰竭、药物难治性心律失常",
              value: 3,
            },
            { label: "心源性休克、心脏骤停、严重血流动力学不稳定", value: 4 },
            { label: "心源性猝死、大面积心肌梗死", value: 5 },
          ],
          showWhen: "sideEffectSystems", // 条件显示
        },
        {
          sort: 5,
          type: "textarea",
          label: "其他不良反应主要是",
          prop: "adverseReaction",
          required: true,
          showWhen: "sideEffectSystems", // 条件显示
        },
        {
          type: "upload",
          label:
            "您可以上传您用药后的病症或检查的结果，以便医生更好的了解您的病情变化",
          prop: "inspectionResult",
          required: false,
          limit: 9, // 最大上传数量
        },
      ],

      // 对应的表单数据模型
      formData: {
        standard: null,
        effectTime: null,
        effectTimeOther: 8, // 新增字段用于存储"其他"选项的输入值
        hasSideEffect: null,
        sideEffectSystems: null,
        gastrointestinalReactionSymptoms: [],
        hemogramReports: [{ pic: "", path: "" }],
        liverKidneyReports: [{ pic: "", path: "" }],
        rashReactionSymptoms: null,
        allergicReactionSymptoms: null,
        neurologicalSymptoms: null,
        headacheSymptom: null,
        cardiovascularSymptoms: null,
        adverseReaction: null,
        inspectionResult: [{ pic: "", path: "" }],
      },

      // 验证规则配置
      rules: {
        standard: [
          {
            required: true,
            message: "请选择疗效初步判断标准",
            trigger: "change",
          },
        ],
        effectTime: [
          {
            required: true,
            message: "请选择有效结果起效时间",
            trigger: "change",
            validator: validateEffectTime, // 使用自定义验证
          },
        ],
        hasSideEffect: [
          {
            required: true,
            message: "请选择是否有不良反应",
            trigger: "change",
          },
        ],
        sideEffectSystems: [
          { required: true, message: "请选择不良反应系统", trigger: "change" },
        ],
        gastrointestinalReactionSymptoms: [
          {
            required: true,
            message: "请选择胃肠道反应症状",
            trigger: "change",
          },
        ],
        hemogramReports: [
          {
            required: true,
            message: "请上传你的血像检查报告",
            trigger: "change",
            validator: validateImg,
          },
        ],
        liverKidneyReports: [
          {
            required: true,
            message: "请上传肝肾功能报告",
            trigger: "change",
            validator: validateImg,
          },
        ],
        rashReactionSymptoms: [
          { required: true, message: "请选择皮疹反应", trigger: "change" },
        ],
        allergicReactionSymptoms: [
          { required: true, message: "请选择过敏反应", trigger: "change" },
        ],
        neurologicalSymptoms: [
          { required: true, message: "请选择周围神经反应", trigger: "change" },
        ],
        headacheSymptom: [
          { required: true, message: "请选择头痛反应", trigger: "change" },
        ],
        cardiovascularSymptoms: [
          {
            required: true,
            message: "请选择心血管系统反应",
            trigger: "change",
          },
        ],
        adverseReaction: [
          { required: true, message: "请填写其他不良反应", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
    isDisabled() {
      return this.$route.query.is_look == 1;
    },
  },
  created() {
    if (this.$route.query.is_look == 1) {
      this.getDetail();
    }
  },
  methods: {
    // 过滤
    filterEmptyObjects(arr) {
      return arr.filter((item) => item.pic !== "" || item.path !== "");
    },
    //获取详情
    getDetail() {
      let consult_inquiry_id = this.$route.query.consult_inquiry_id;
      this.axios
        .post("platform/Inquirysheet/getConsultInquiryInfo", {
          consult_inquiry_id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.formData = res.data.content.webContent;
            this.formData.hemogramReports = this.filterEmptyObjects(
              this.formData.hemogramReports
            );
            this.formData.liverKidneyReports = this.filterEmptyObjects(
              this.formData.liverKidneyReports
            );
            this.formData.inspectionResult = this.filterEmptyObjects(
              this.formData.inspectionResult
            );
          }
        });
    },
    shouldShow(item) {
      if (!item.showWhen) return true;
      if (item.showWhen === "hasSideEffect" && this.formData.hasSideEffect == 1)
        return true;

      // 处理不良反应系统的显示逻辑
      if (
        item.showWhen === "sideEffectSystems" &&
        this.formData.hasSideEffect == 1
      ) {
        // 特定症状的显示逻辑
        switch (item.prop) {
          case "hemogramReports":
            return this.formData.sideEffectSystems === 1;
          case "gastrointestinalReactionSymptoms":
            return this.formData.sideEffectSystems === 2;
          case "liverKidneyReports":
            return this.formData.sideEffectSystems === 3;
          case "rashReactionSymptoms":
            return this.formData.sideEffectSystems === 4;
          case "allergicReactionSymptoms":
            return this.formData.sideEffectSystems === 5;
          case "neurologicalSymptoms":
            return this.formData.sideEffectSystems === 6;
          case "headacheSymptom":
            return this.formData.sideEffectSystems === 6;
          case "cardiovascularSymptoms":
            return this.formData.sideEffectSystems === 7;
          case "adverseReaction":
            return this.formData.sideEffectSystems === 8;
        }
      }
    },
    emitImg(data, index, isDel, item) {
      if (isDel) {
        this.formData[item.prop].splice(index, 1);
      } else {
        this.formData[item.prop][index].pic = data.pic;
        this.formData[item.prop][index].path = data.path;
      }
      let len = this.formData[item.prop].length;
      if (len < item.limit && this.formData[item.prop][len - 1].pic != "") {
        this.formData[item.prop].push({
          pic: "",
          path: "",
        });
      }
    },

    handleRadioChange(item) {
      let { prop } = item;
      if (prop == "sideEffectSystems") {
        const keyArr = [
          "hemogramReports",
          "gastrointestinalReactionSymptoms",
          "liverKidneyReports",
          "rashReactionSymptoms",
          "allergicReactionSymptoms",
          "neurologicalSymptoms",
          "headacheSymptom",
          "cardiovascularSymptoms",
          "adverseReaction",
        ];

        keyArr.forEach((key) => {
          if (key == "hemogramReports" || key == "liverKidneyReports") {
            this.formData[key] = [{ pic: "", path: "" }];
          } else if (key == "gastrointestinalReactionSymptoms") {
            this.formData[key] = [];
          } else {
            this.formData[key] = null;
          }
        });
        this.$nextTick(() => {
          this.$refs["formRef"].clearValidate();
        });
      }
    },

    // 数据处理
    enhanceFormConfig(formConfig, formData) {
      // 深拷贝原始配置
      const enhancedConfig = JSON.parse(JSON.stringify(formConfig));

      // 创建值映射表，便于快速查找
      const valueMap = new Map();
      enhancedConfig.forEach((item) => {
        if (item.options) {
          valueMap.set(
            item.prop,
            new Map(item.options.map((opt) => [opt.value, opt.label]))
          );
        }
      });

      // 处理每个配置项
      enhancedConfig.forEach((item) => {
        const propValue = formData[item.prop];
        let hasValue = false;

        // 根据不同类型判断是否有值
        switch (item.type) {
          case "radio":
          case "textarea":
            hasValue = propValue !== null && propValue !== undefined;
            break;
          case "checkbox":
          case "upload":
            hasValue = Array.isArray(propValue) && propValue.length > 1;
            break;
          default:
            hasValue = propValue !== null && propValue !== undefined;
        }

        // 添加 isShow 属性
        item.isShow = hasValue;

        // 如果有值，添加 value 属性
        if (hasValue) {
          switch (item.type) {
            case "radio":
              // 特殊处理 effectTime 的 "other" 情况
              if (item.prop === "effectTime" && propValue === "other") {
                item.value =
                  formData.effectTimeOther !== undefined
                    ? formData.effectTimeOther
                    : "其他";
              }
              // 正常处理其他 radio 项
              else if (valueMap.has(item.prop)) {
                const label = valueMap.get(item.prop).get(propValue);
                if (label) item.value = label;
              }
              break;
            case "checkbox":
              if (valueMap.has(item.prop)) {
                const labelMap = valueMap.get(item.prop);
                item.value = propValue
                  .map((val) => labelMap.get(val))
                  .filter(Boolean);
              }
              break;
            case "upload":
              item.value = [...propValue]; // 复制数组
              break;
            case "textarea":
              item.value = propValue;
              break;
          }
        }
      });

      return enhancedConfig;
    },

    submit() {
      let { consult_inquiry_id } = this.$route.query;
      let h5Content = this.enhanceFormConfig(this.formConfig, this.formData);
      let webContent = Object.assign({}, this.formData);
      let content = {
        h5Content,
        webContent,
      };
      let params = Object.assign(
        { consult_inquiry_id },
        { content: JSON.stringify(content) }
      );
      this.$refs["formRef"].validate((valid) => {
        if (valid) {
          const loading = this.$loading();
          this.axios
            .post("platform/Inquirysheet/submitConsultInquiryInfo", params)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("提交成功");
                this.back();
              }
              loading.close();
            })
            .catch(() => {
              loading.close();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    back() {
      history.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.content-box {
  .el-form {
    ::v-deep .el-form-item__content {
      height: auto;
    }
  }
}
</style>
